// src/views/AttendanceMaster/AttendanceMasterPage.jsx
import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Spinner,
  Alert,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormText,
  Form,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import useVendorBranch from '../../utils/useVendorBranch';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import conditionalDataLoad from '../../utils/conditionalDataLoad';

const CLASS_DROPDOWN_URL = 'api/ClassMaster/GetClassMaster';
const BATCH_BY_CLASS_URL = 'api/BatchMaster/GetAllBatch';

// Multi Purpose (Reason) API – FLAG BASED
const MULTI_PURPOSE_API_GET =
  'api/Multi_Purpose_Type_Master/GetMulti_Purpose_Type_Master';
const MULTI_PURPOSE_API_ADD =
  'api/Multi_Purpose_Type_Master/AddMulti_Purpose_Type_Master';
const MULTI_PURPOSE_API_UPDATE =
  'api/Multi_Purpose_Type_Master/UpdateMulti_Purpose_Type_Master';

const AttendanceMasterPage = () => {
  const navigate = useNavigate();

  // 🔹 User + vendor/branch capability
  const { user } = useSelector((state) => state.authState);
  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  // 🔹 Vendor / Branch selection
  const [selectionData, setSelectionData] = useState({
    vendor_id: user?.vendor_id || 0,
    branch_id: user?.branch_id || 0,
  });
  const [vbErrorMessage, setVbErrorMessage] = useState({});

  const [classes, setClasses] = useState([]);
  const [batches, setBatches] = useState([]);

  const [selectedClassId, setSelectedClassId] = useState('');
  const [selectedBatchId, setSelectedBatchId] = useState('');
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substring(0, 10)
  );

  const [loadingClasses, setLoadingClasses] = useState(false);
  const [loadingBatches, setLoadingBatches] = useState(false);
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  // ---- reason master ke state ----
  const [reasonList, setReasonList] = useState([]);
  const [reasonModal, setReasonModal] = useState(false);
  const [reasonMpData, setReasonMpData] = useState({
    id: 0,
    multi_purpose_flag: 'AttendanceReason',
    multi_purpose_code: '',
    multi_purpose_type: '',
    multi_purpose_remark: '',
  });
  const [reasonMpErrors, setReasonMpErrors] = useState({});

  const toggleReasonModal = () => setReasonModal(!reasonModal);

  const handleReasonMpChange = (e) => {
    const { name, value } = e.target;
    setReasonMpData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setReasonMpErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  const validateReasonMp = () => {
    const errs = {};
    if (!reasonMpData.multi_purpose_type?.trim()) {
      errs.multi_purpose_type = 'Reason text is required.';
    }
    return errs;
  };

  const loadReasonList = async () => {
    try {
      const url = `${MULTI_PURPOSE_API_GET}?filter=attendancereason`;
      const res = await apiService.get(url);
    
      const allData = res.data;

      setReasonList(allData);
    } catch (err) {
      console.error('Error loading attendance reasons:', err);
      toast.error('Error while loading attendance reasons');
    }
  };

  const saveReasonMaster = async () => {
    const errs = validateReasonMp();
    if (Object.keys(errs).length > 0) {
      setReasonMpErrors(errs);
      return;
    }

    try {
      const config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const data = JSON.stringify(reasonMpData);

      let response;
      if (!reasonMpData.id || reasonMpData.id === 0 || reasonMpData.id === '0') {
        response = await apiService.post(MULTI_PURPOSE_API_ADD, data, config);
      } else {
        response = await apiService.put(
          `${MULTI_PURPOSE_API_UPDATE}?id=${reasonMpData.id}`,
          data,
          config
        );
      }

      const apiRoot = response?.data ?? response;
      const ok =
        apiRoot?.status === true ||
        apiRoot?.Status === true ||
        apiRoot?.status === 'true';

      if (ok) {
        toast.success(apiRoot.message || apiRoot.Message || 'Reason saved.');
        setReasonModal(false);
        setReasonMpData({
          id: 0,
          multi_purpose_flag: 'AttendanceReason',
          multi_purpose_code: '',
          multi_purpose_type: '',
          multi_purpose_remark: '',
        });
        setReasonMpErrors({});
        await loadReasonList();
      } else {
        toast.error(
          apiRoot?.message || apiRoot?.Message || 'Failed to save reason.'
        );
      }
    } catch (err) {
      console.error('Error saving reason:', err);
      toast.error('Error while saving reason.');
    }
  };

  // ---- REASONS 1 bar load ----
  useEffect(() => {
    loadReasonList();
  }, []);

  // 🔁 Vendor/branch change pe selection reset
  // useEffect(() => {
  //   setSelectedClassId('');
  //   setSelectedBatchId('');
  //   setBatches([]);
  // }, [selectionData.vendor_id, selectionData.branch_id]);

  // ---- CLASS LIST: vendorId + branchId required ----
  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) {

    loadClasses();
    }

  }, [
    selectionData.vendor_id,
    selectionData.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
  ]);

  
    const loadClasses = async () => {
      try {
        setLoadingClasses(true);
        setError('');
        setSuccessMsg('');

        const params = new URLSearchParams();
        if (selectionData.vendor_id && selectionData.vendor_id !== 0) {
          params.append('vendorId', selectionData.vendor_id);
        }
        if (selectionData.branch_id && selectionData.branch_id !== 0) {
          params.append('branchId', selectionData.branch_id);
        }
        params.append('searchItem', '');

        const url = `${CLASS_DROPDOWN_URL}?${params.toString()}`;

        const res = await apiService.get(url);
        const raw = res?.data ?? res;

        let data = [];

        if (raw?.status === true || raw?.Status === true) {
          const list = raw.data || raw.Data || [];
          data = Array.isArray(list) ? list : [];
        } else if (raw?.status === false || raw?.Status === false) {
          const list = raw.data || raw.Data || [];
          if (Array.isArray(list)) {
            data = list;
          }
          const msg = raw?.message || raw?.Message;
          if (msg) {
            setError(msg);
          }
        } else if (Array.isArray(raw?.Data)) {
          data = raw.Data;
        } else if (Array.isArray(raw?.data)) {
          data = raw.data;
        } else if (Array.isArray(raw)) {
          data = raw;
        }

        setClasses(data || []);
      } catch (err) {
        console.error('Error loading classes:', err);
        setError('Class list load karte waqt error aaya.');
        setClasses([]);
      } finally {
        setLoadingClasses(false);
      }
    };

  const handleClassChange = async (e) => {
    const val = e.target.value;
    setSelectedClassId(val);
    setSelectedBatchId('');
    setBatches([]);
    setError('');
    setSuccessMsg('');

    if (!val) return;

    try {
      setLoadingBatches(true);

      const params = new URLSearchParams();
      params.append('classId', val);
      if (selectionData.vendor_id && selectionData.vendor_id !== 0) {
        params.append('vendorId', selectionData.vendor_id);
      }
      if (selectionData.branch_id && selectionData.branch_id !== 0) {
        params.append('branchId', selectionData.branch_id);
      }

      const url = `${BATCH_BY_CLASS_URL}?${params.toString()}`;

      const res = await apiService.get(url);
      const raw = res?.data ?? res;

      let data = [];
      if (Array.isArray(raw)) data = raw;
      else if (Array.isArray(raw?.data)) data = raw.data;
      else if (Array.isArray(raw?.Data)) data = raw.Data;

      setBatches(data || []);
    } catch (err) {
      console.error('Error loading batches:', err);
      setBatches([]);
    } finally {
      setLoadingBatches(false);
    }
  };

  const handleBatchChange = (e) => {
    const val = e.target.value;
    setSelectedBatchId(val);
    setError('');
    setSuccessMsg('');
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
    setError('');
    setSuccessMsg('');
  };

  // 🔴 Load Students -> next page (vendor/branch bhi state me bhejo)
  const handleLoadStudents = () => {
    setError('');
    setSuccessMsg('');

    // Vendor / Branch validation – same pattern
    if (isSuperAdmin) {
      if (!selectionData.vendor_id || Number(selectionData.vendor_id) <= 0) {
        toast.error('Please select a Vendor');
        return;
      }
    }

    if (isAdmin || hasMultiBranch) {
      if (!selectionData.branch_id || Number(selectionData.branch_id) <= 0) {
        toast.error('Please select a Branch');
        return;
      }
    }

    if (!selectedClassId) {
      setError('Please select a class.');
      return;
    }
    if (!selectedDate) {
      setError('Please select a date.');
      return;
    }

    navigate('/attendance-student-list', {
      state: {
        classId: selectedClassId,
        batchId: selectedBatchId || null,
        date: selectedDate,
        reasonList,
        vendorId: selectionData.vendor_id || null,
        branchId: selectionData.branch_id || null,
      },
    });
  };

  return (
    <div className='container-fluid mt-3'>
      {/* 🔹 Vendor / Branch selector */}
      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={vbErrorMessage}
        accessButton={true}
      />

      <Row>
        <Col md='12'>
          <Card className='card-box height-100-p pd-20 mb-20'>
            <CardBody>
              <Row>
                {/* Class */}
                <Col md='3'>
                  <FormGroup>
                    <Label for='classSelect'>Class</Label>
                    {loadingClasses ? (
                      <div className='d-flex align-items-center'>
                        <Spinner size='sm' className='mr-2' /> Loading
                        classes...
                      </div>
                    ) : (
                      <Input
                        type='select'
                        id='classSelect'
                        className='custom-select'
                        value={selectedClassId}
                        onChange={handleClassChange}
                      >
                        <option value=''>-- Select Class --</option>
                        {classes.map((cls, index) => {
                          const id = cls.id ?? cls.Id ?? cls.ID ?? index;
                          return (
                            <option key={id} value={id}>
                              {cls.class_display_name ||
                                cls.class_display_Name ||
                                cls.class_Name ||
                                `Class #${id}`}
                            </option>
                          );
                        })}
                      </Input>
                    )}
                  </FormGroup>
                </Col>

                {/* Batch */}
                <Col md='3'>
                  <FormGroup>
                    <Label for='batchSelect'>Batch</Label>
                    {loadingBatches ? (
                      <div className='d-flex align-items-center'>
                        <Spinner size='sm' className='mr-2' /> Loading
                        batches...
                      </div>
                    ) : (
                      <Input
                        type='select'
                        className='custom-select'
                        id='batchSelect'
                        value={selectedBatchId}
                        onChange={handleBatchChange}
                      >
                        <option value=''>-- All Batches --</option>
                        {batches.map((b, index) => {
                          const id = b.id ?? b.batch_id ?? b.BatchId ?? index;
                          return (
                            <option key={index} value={id}>
                              {b.batch_code} - {b.batch_start_time}
                            </option>
                          );
                        })}
                      </Input>
                    )}
                  </FormGroup>
                </Col>

                {/* Date */}
                <Col md='3'>
                  <FormGroup>
                    <Label for='dateSelect'>Date</Label>
                    <Input
                      type='date'
                      id='dateSelect'
                      value={selectedDate}
                      onChange={handleDateChange}
                    />
                  </FormGroup>
                </Col>

                {/* Load Students */}
              <Col md="3">
  <FormGroup>
    <Label for="dateSelect">Action</Label>
    <Button
      color="primary"
      className="text-white w-100"
      onClick={handleLoadStudents}
      disabled={!selectedClassId}
    >
      Load Students
    </Button>
  </FormGroup>
</Col>

              </Row>

              {error && (
                <Row className='mt-2'>
                  <Col md='12'>
                    <Alert color='danger'>{error}</Alert>
                  </Col>
                </Row>
              )}

              {/* Reason master modal (optional) */}
              <Modal centered isOpen={reasonModal} toggle={toggleReasonModal}>
                <ModalHeader toggle={toggleReasonModal}>
                  Add new Attendance Reason
                </ModalHeader>
                <ModalBody>
                  <Form>
                    <FormGroup>
                      <Label htmlFor='multi_purpose_type'>
                        Enter new Attendance Reason :
                      </Label>
                      <Input
                        id='multi_purpose_type'
                        name='multi_purpose_type'
                        value={reasonMpData.multi_purpose_type}
                        onChange={handleReasonMpChange}
                      />
                      {reasonMpErrors.multi_purpose_type && (
                        <FormText color='danger'>
                          {reasonMpErrors.multi_purpose_type}
                        </FormText>
                      )}
                    </FormGroup>
                  </Form>
                </ModalBody>
                <ModalFooter>
                  <Button color='primary' onClick={saveReasonMaster}>
                    Submit
                  </Button>
                  <Button color='secondary' onClick={toggleReasonModal}>
                    Cancel
                  </Button>
                </ModalFooter>
              </Modal>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AttendanceMasterPage;
